<script>
    import { Meteor } from "meteor/meteor";
    import { Tracker } from "meteor/tracker";
    import { onMount } from "svelte";
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";
    import { InventoryCollection } from "../../api/inventory/inventory";
    import InventoryCard from "../components/InventoryCard.svelte";
    import ContactLeadForm from "../components/ContactLeadForm.svelte";

    let vehicles = $state([]);
    let subReady = $state(false);

    onMount(() => {
        const handle = Meteor.subscribe("inventory.featured");
        const computation = Tracker.autorun(() => {
            subReady = handle.ready();
            vehicles = InventoryCollection.find(
                {},
                { sort: { featured: -1 } },
            ).fetch();
        });

        return () => {
            computation.stop();
            handle.stop();
        };
    });
</script>

<section class="home-banner">
    <button
        class="banner-link"
        type="button"
        onclick={() => FlowRouter.go("/financing")}
        aria-label="Go to financing"
    >
        <picture>
            <source srcset="/images/banner.webp" type="image/webp" />
            <img
                src="/images/banner.png"
                alt="VGO Auto Financing featured banner"
                loading="lazy"
            />
        </picture>
    </button>
</section>

<section class="hero">
    <div class="hero-copy">
        <p class="eyebrow">Premium Auto Brokerage & Financing</p>
        <h1>Drive Better. Finance Smarter.</h1>
        <p>
            At our dealership, we are devoted to turning your dream car into a
            reality. Our steadfast commitment to customer support ensures that
            assist you at every stage, helping you discover the ideal vehicle
            that suits your requirements.
        </p>
        <p>
            Don't see the vehicle you want? Call us, we'll find it for you.
            Don't like the price? Call us, we'll find you the price you can
            afford.
        </p>
        <div class="hero-actions">
            <button type="button" onclick={() => FlowRouter.go("/financing")}
                >Explore Financing Options</button
            >
        </div>
    </div>
    <!--
  <div class="hero-logo-wrap">
    <img src="/images/logo.svg" alt="VGO Auto Financing logo" />
  </div>
  -->
</section>

<section>
    <h2>Featured Listings</h2>
    {#if !subReady}
        <p>Loading inventory...</p>
    {:else if vehicles.length === 0}
        <p>Featured inventory will appear here shortly.</p>
    {:else}
        <div class="inventory-grid two-wide">
            {#each vehicles as vehicle (vehicle._id)}
                <InventoryCard {vehicle} />
            {/each}
        </div>
    {/if}
</section>

<section class="contact-lite">
    <ContactLeadForm heading="Get in touch..." submitLabel="Say Hello" />
</section>
